import type { PropsWithChildren } from "react";

export type StepProps = PropsWithChildren<{
    label: string;
}>;

export default function Step(props: StepProps) {
    return null;
}
